<template>
  <vb-modal
    :ref="ref_id"
    :vb_options="{
      id: ref_id,
      size: 'lg',
      title: 'Dettaglio del viaggio',
      hide_footer: true, 
    }"
  >
    <div class="flight-pad-details-modal">
      <main class="flight-pad-details-modal__main">
        <flight-pad-details :flight_offer="flight_offer" show_dates />
      </main>
      <footer v-if="selectable" class="flight-pad-details-modal__footer">
        <div>
          <!-- empty -->
        </div>
        <flight-pad-price-button
          :flight_offer="flight_offer"
          direction="horizontal"
        />
      </footer>
    </div>
  </vb-modal>
</template>

<script>
import FlightPadDetails from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details.vue";
import FlightPadPriceButton from "@liveflight/components/blocks/flight-pad/flight-pad-price-button.vue";

export default {
  name: "flight-pad-details-modal",
  components: {
    "flight-pad-details": FlightPadDetails,
    "flight-pad-price-button": FlightPadPriceButton,
  },
  props: {
    wrapper_id: {
      type: String,
      required: true,
    },
    flight_offer: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ref_id() {
      return `internal:${this.wrapper_id}`;
    },
  },
  methods: {
    show_modal() {
      this.$bvModal.show(this.ref_id);
    },
    hide_modal() {
      this.$bvModal.hide(this.ref_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-details-modal {
  padding: 15px;
  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
  &__main {
    border-top: 1px solid $light-gray;
  }
  &__footer {
    padding-top: 15px;
    border-top: 1px solid $light-gray;
    display: flex;
    justify-content: flex-end;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }

  .close:hover {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
  .close:focus {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
  .close:active {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
  }
}
</style>
